/**
 * Design System - Typography Tokens
 * Defines font families, sizes, weights, and line heights
 */

export const typography = {
  // Font families
  fontFamily: {
    base: '"Noto Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    heading: '"Noto Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    mono: '"Roboto Mono", "Courier New", monospace',
  },

  // Font weights
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },

  // Font sizes (mobile-first)
  fontSize: {
    // Display
    display1: '3rem', // 48px
    display2: '2.5rem', // 40px
    display3: '2rem', // 32px

    // Heading
    heading1: '2rem', // 32px
    heading2: '1.75rem', // 28px
    heading3: '1.5rem', // 24px
    heading4: '1.25rem', // 20px
    heading5: '1.125rem', // 18px
    heading6: '1rem', // 16px

    // Body
    body: '1rem', // 16px
    bodySmall: '0.875rem', // 14px
    bodyExtraSmall: '0.75rem', // 12px

    // Label
    label: '0.875rem', // 14px
    labelSmall: '0.75rem', // 12px

    // Code
    code: '0.8125rem', // 13px
  },

  // Line heights
  lineHeight: {
    tight: 1.2,
    normal: 1.5,
    relaxed: 1.75,
    loose: 2,
  },

  // Letter spacing
  letterSpacing: {
    tight: '-0.02em',
    normal: '0',
    wide: '0.04em',
    wider: '0.08em',
  },

  // Preset text styles for components
  styles: {
    // Display styles
    display1: {
      fontSize: '3rem',
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: '-0.02em',
    },
    display2: {
      fontSize: '2.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: '-0.02em',
    },

    // Heading styles
    h1: {
      fontSize: '2rem',
      fontWeight: 700,
      lineHeight: 1.3,
      letterSpacing: '-0.01em',
    },
    h2: {
      fontSize: '1.75rem',
      fontWeight: 700,
      lineHeight: 1.3,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h4: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1.125rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },

    // Body styles
    body: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    bodyMedium: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    bodySmall: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    bodySmallMedium: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    bodyExtraSmall: {
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: 1.4,
    },

    // Label styles
    label: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    labelSmall: {
      fontSize: '0.75rem',
      fontWeight: 500,
      lineHeight: 1.4,
      letterSpacing: '0.04em',
    },

    // Code styles
    code: {
      fontSize: '0.8125rem',
      fontWeight: 500,
      lineHeight: 1.5,
    },

    // Custom hero/featured styles (based on design specifications)
    heroTitle: {
      fontSize: '2.5rem', // 40px
      fontWeight: 600, // Semi Bold
      lineHeight: 1.0,
      letterSpacing: '-0.02em',
      textAlign: 'right',
    },
    heroSubtitle: {
      fontSize: '1.75rem', // 28px
      fontWeight: 600, // Semi Bold
      lineHeight: 1.0,
      letterSpacing: '-0.01em',
      textAlign: 'right',
    },
    featuredText: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.0,
      textAlign: 'justify',
    },
    leadText: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.0,
      fontStyle: 'italic',
      textAlign: 'left',
    },
  },
};
